/* eslint-disable indent */
/* eslint-disable array-bracket-newline */
import {
  formatAddress,
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import StatsMobile, { IStatsMobileProps } from '../mobile/Stats';
import { formatTimestamp, toFixed4 } from '../formatters';
import Loader from '../../common/Loader';
import { ITradesSelector } from '.';

interface ITradesTableMobileProps extends ITradesSelector {
  loading: boolean;
  openWallet: (tx: string) => void;
}

const getColorForItem = (row: any) => {
  if (row.side === 'Buy') {
    return 'green';
  }
  return 'red';
};

const TradesTableMobile = ({
  openWallet,
  trades,
  base,
  quote,
  address,
  quote_decimals,
  chain,
  loading,
}: ITradesTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date',
        accessor: 'timestamp',
        parser: (value) => formatTimestamp(value),
        width: 130,
      },
      item_2: {
        name: 'Price ($)',
        accessor: 'priceUSD',
        parser: (value) => toFixed4(value),
      },
      item_3: {
        name: quote,
        accessor: 'price',
        parser: (value) => `(${toFixed4(value)})`,
      },
    },
    row_2: {
      item_1: {
        name: 'Amount',
        accessor: 'numericIn',
        parser: (value) => `${toFixed4(value)} ${base}`,
        width: 130,
      },
      item_2: {
        name: 'Total',
        accessor: 'numericOut',
        parser: (value) => `${toFixed4(value)} ${quote}`,
      },
    },
    row_3: {
      item_1: {
        name: 'Tx Value ($)',
        accessor: 'txValue',
        parser: (value) => toFixed4(value),
        width: 130,
      },
      item_2: {
        name: 'Address',
        accessor: 'wallet',
        parser: (value) => formatAddress(value),
        onClick: (row) => openWallet(row.wallet),
        color: 'navy',
      },
    },
  };

  const renderFooter = (props: any) => <StatsMobile {...props} />;
  const footerData: Omit<IStatsMobileProps, 'data' | 'actionShowModal'> = {
    quote_decimals,
    quote,
    address,
    chain,
  };

  const parsedData =
    !loading && trades.length
      ? formatMobileTableData({
          data: trades,
          schema,
          getColorForItem,
          renderFooter,
          footerData,
        })
      : undefined;

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !trades.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        parsedData?.map((row, index) => (
          <TableCardMobile key={index} data={row} />
        ))
      )}
    </div>
  );
};

export default TradesTableMobile;
